
interface ExperienceFiltersProps {
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
  selectedLocation: string;
  setSelectedLocation: (location: string) => void;
}

export default function ExperienceFilters({ 
  selectedCategory, 
  setSelectedCategory, 
  selectedLocation, 
  setSelectedLocation 
}: ExperienceFiltersProps) {
  const categories = [
    { value: 'all', label: 'All Categories' },
    { value: 'forest', label: 'Forest' },
    { value: 'desert', label: 'Desert' },
    { value: 'lakeside', label: 'Lakeside' },
    { value: 'mountain', label: 'Mountain' },
    { value: 'coastal', label: 'Coastal' },
    { value: 'vineyard', label: 'Vineyard' }
  ];

  const locations = [
    { value: 'all', label: 'All Locations' },
    { value: 'pacific', label: 'Pacific Northwest' },
    { value: 'arizona', label: 'Arizona' },
    { value: 'tahoe', label: 'Lake Tahoe' },
    { value: 'rocky', label: 'Rocky Mountains' },
    { value: 'big sur', label: 'Big Sur' },
    { value: 'napa', label: 'Napa Valley' }
  ];

  return (
    <div className="bg-gray-50 p-6 rounded-lg">
      <h3 className="text-lg font-semibold mb-4">Filter Experiences</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Category</label>
          <div className="relative">
            <select 
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 pr-8 cursor-pointer"
            >
              {categories.map((category) => (
                <option key={category.value} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
            <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Location</label>
          <div className="relative">
            <select 
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 pr-8 cursor-pointer"
            >
              {locations.map((location) => (
                <option key={location.value} value={location.value}>
                  {location.label}
                </option>
              ))}
            </select>
            <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
